import { render, staticRenderFns } from "./rentShopDetails.vue?vue&type=template&id=4a0ddfa2&scoped=true&"
import script from "./rentShopDetails.vue?vue&type=script&lang=js&"
export * from "./rentShopDetails.vue?vue&type=script&lang=js&"
import style0 from "./rentShopDetails.vue?vue&type=style&index=0&lang=less&"
import style1 from "./rentShopDetails.vue?vue&type=style&index=1&id=4a0ddfa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ddfa2",
  null
  
)

export default component.exports